export default {
      id: "input__select-4-usage",
      viewBox: "0 0 10 5",
      url: __webpack_public_path__ + "img/icons.svg#input__select-4",
      toString: function () {
        return this.url;
      }
    }